module.exports = __webpack_public_path__ + "fonts/NotoSansJP-Regular.dd4fa7df.ttf";